import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const spinnerSize = 90;
const antIcon = <LoadingOutlined style={{ fontSize: spinnerSize }} spin />;

// spinner to show/hide on page load or on making api calls
export const LoadingComponent = () => {
  return (
    <>
      <div
        className="loadingWrapper"
        style={{
          position: 'fixed',
          width: '100%',
          height: '100%',
          background: 'black',
          opacity: '0.5',
          zIndex: '99999',
        }}
      >
        <div
          className="spinWrapper"
          style={{
            position: 'relative',
            top: '50%',
            left: '50%',
            width: `${spinnerSize}px`,
            transform: 'translate(-50%, -50%)',
          }}
        >
          <Spin indicator={antIcon} size="large" />
        </div>
      </div>
    </>
  );
};

export const PageLoader = () => {
  return (
    <div
      className="loadingWrapper"
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        background: 'black',
        opacity: '0.5',
        zIndex: '99999',
      }}
    >
      <div
        className="spinWrapper"
        style={{
          position: 'relative',
          top: '50%',
          left: '50%',
          width: `${spinnerSize}px`,
          transform: 'translate(-50%, -50%)',
        }}
      >
        <Spin indicator={antIcon} size="large" />
      </div>
    </div>
  );
};
